module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Git#2-461e1152127b97bbdc03237e567f9e525b4e1ac879408e75c2b94492b42d7763.svg";